import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import copy from 'copy-to-clipboard'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { FeatureOf, Point } from 'models/map'
import styles from '../Confirmation.module.scss'

type PointDescriptionProps = {
  selectedFeature: FeatureOf<Point>
}

export const PointDescription: FC<PointDescriptionProps> = ({ selectedFeature }) => {
  const { t } = useTranslation()
  const { coordinates = [] } = selectedFeature?.geometry || {}
  const onCopy = () => copy(`${coordinates[1]},${coordinates[0]}`)

  return (
    <Text className={styles.center}>
      {t('confirmation_banner.latitude')} {coordinates[1]?.toFixed(4)},{' '}
      {t('confirmation_banner.longitude')} {coordinates[0]?.toFixed(4)}
      <button
        className={styles.copy}
        onClick={onCopy}
        aria-label={t('confirmation_banner.copy_coordinates')}
      >
        <Icon name="file-copy-line" />
      </button>
    </Text>
  )
}

PointDescription.displayName = 'PointDescription'
